import flat from "flat";
import localeUS from "./en-US.json";
import localeES from "./es.json";
import localeCN from "./zh-CN.json";
import localeJA from "./ja.json";
import localeSV from "./sv.json";
import localeNL from "./nl.json";
import localeIT from "./it.json";
import localePT from "./pt.json";
import localeDE from "./de.json";

type LanguageTag = "default" | "en-US" | "zh-CN" | "es" | "ja" | "sv" | "nl" | "it" | "pt" | "de";
const defaultLang = flat(localeUS);
const LANGUAGES = [
  {
    key: "en-US",
    name: "English",
  },
  {
    key: "es",
    name: "Español"
  },
  {
    key: "zh-CN",
    name: "中文"
  },
  {
    key: "ja",
    name: "日本語"
  },
  {
    key: "sv",
    name: "Svenska"
  },
  {
    key: "nl",
    name: "Dutch"
  },
  {
    key: "it",
    name: "Italiano"
  },
  {
    key: "pt",
    name: "Português"
  },
  {
    key: "de",
    name: "Deutsch"
  }
];

const LOCALES_DATA: { [name in LanguageTag]: any } = {
  default: defaultLang,
  "en-US": defaultLang,
  "es": flat(localeES),
  "zh-CN": flat(localeCN),
  "ja": flat(localeJA),
  "sv": flat(localeSV),
  "nl": flat(localeNL),
  "it": flat(localeIT),
  "pt": flat(localePT),
  "de": flat(localeDE),
};

export { LANGUAGES, LOCALES_DATA };
